import React, { useState } from "react";
import items from "./data";

const Categories = ({ setCategory }) => {
  const uniqueCategories = new Set();

  items.forEach((item) => {
    uniqueCategories.add(item.category);
  });

  function handleClick(category) {
    setCategory(category);
  }

  const allCategories = ["All", ...uniqueCategories];

  return (
    <div className="btn-container">
      {["All", ...uniqueCategories].map((category) => {
        return (
          <button
            type="button"
            className="filter-btn"
            key={category}
            onClick={() => {
              handleClick(category);
            }}
          >
            {category}
          </button>
        );
      })}
    </div>
  );
};

export default Categories;
